import { render, staticRenderFns } from "./AtencaoDomiciliarComponente.vue?vue&type=template&id=0cf44b23"
import script from "./AtencaoDomiciliarComponente.vue?vue&type=script&lang=js"
export * from "./AtencaoDomiciliarComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports